import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["visual", "source", "hidden", "toolbar", "toggle"]

  connect() {
    this.inSource = false
    this.hiddenTarget.value = this.visualTarget.innerHTML
  }

  sync() {
    this.hiddenTarget.value = this.inSource
      ? this.sourceTarget.value
      : this.visualTarget.innerHTML
  }

  preventToolbarBlur(event) {
    if (event.target.closest("[data-cmd]")) event.preventDefault()
  }

  runCommand(event) {
    const btn = event.target.closest("[data-cmd]")
    if (!btn) return
    event.preventDefault()

    const cmd = btn.getAttribute("data-cmd")
    let val = btn.getAttribute("data-val") || null

    if (cmd === "createLink") {
      val = prompt("Enter URL:", "https://")
      if (!val) return
    }

    if (cmd === "formatBlock" && val) {
      val = "<" + val + ">"
    }

    this.visualTarget.focus()
    document.execCommand(cmd, false, val)
    this.sync()
  }

  toggleSource(event) {
    event.preventDefault()
    this.inSource = !this.inSource

    if (this.inSource) {
      this.sourceTarget.value = this.visualTarget.innerHTML
      this.visualTarget.style.display = "none"
      this.toolbarTarget.style.display = "none"
      this.sourceTarget.style.display = "block"
      this.toggleTarget.innerHTML = '<i class="fa fa-eye"></i> Visual Editor'
    } else {
      this.visualTarget.innerHTML = this.sourceTarget.value
      this.sourceTarget.style.display = "none"
      this.visualTarget.style.display = "block"
      this.toolbarTarget.style.display = "block"
      this.toggleTarget.innerHTML = '<i class="fa fa-code"></i> Source Code'
    }

    this.sync()
  }
}
